export default "__VITE_ASSET__8P0PMNhS__"